import React, { useReducer, useContext, useEffect } from 'react'
import { lockedReducer } from '../../Utils/reducers';
import { api } from '../../../services/api';
import { Box, Tooltip, TextField } from '@mui/material'
import DefaultModal from '../../Utils/DefaultModal';
import ColorButton from '../../Buttons/ColorButton';
import toast from 'react-hot-toast';
import validateData from './validateData';

const url = '/alas/'

const getTitle = (data) => {
    if (data?.id)
        return 'Editar'
    return 'Adicionar'
}

const submit = async (data, getData, setLoader, handleClose) => {

    setLoader(true)
    let res = null

    if (data.id)
        res = await api.patch(`${url}${data.id}/`, data)
    else
        res = await api.post(url, data)
    if (res.status === 201 || res.status === 200) {
        toast.success(`Ala ${res.status === 201 ? 'adicionada' : 'editada'} com sucesso`)
        getData()
        handleClose()
        setLoader(false)
        return
    }
    toast.error(`Ala não pôde ser ${!data.id ? 'adicionada' : 'editada.'} Motivo: ${res.data}`)
    setLoader(false)
}


const EditAla = ({ data, reloadData, setLoader, handleClose }) => {

    const [state, setState] = useReducer(lockedReducer, {
        nome: '',

        ...data,
        id: data.id ? data.id : 0
    })

    const validData = validateData(state)

    return (
        <>
            <DefaultModal
                open={true}
                title={
                    `${getTitle(state)} Ala`
                }
                handleClose={handleClose}
                content={
                    <>
                        <Box className='item-content-modal noborder' >

                            <Box className='item-profile-row'>
                                <TextField
                                    id="nome"
                                    type="text"
                                    label="Nome"
                                    value={state.nome}
                                    onChange={(e) => { setState({ 'nome': e.target.value }) }}
                                    fullWidth={false}
                                    size='small'
                                    inputProps={{
                                        maxLength: 50
                                    }}
                                />
                            </Box>

                        </Box>
                    </>
                }
                action={
                    <>
                        <Tooltip placement="left" title={validData}>
                            <Box>
                                <ColorButton
                                    onClick={() => submit(state, reloadData, setLoader, handleClose)}
                                    disabled={validData}
                                >Salvar
                                </ColorButton>
                            </Box>
                        </Tooltip>
                    </>
                }
            />

        </>
    )
}

export default EditAla;